$(function () {
  // Comparison

  const setComparisonCounter = (count) => {
    const value = parseInt(count);
    if (!isNaN(value)) {
      $(".js-comparison-counter").each(function () {
        if (value > 0) {
          $(this).removeClass("d-none");
        } else {
          $(this).addClass("d-none");
        }
        $(this).html(value > 0 ? (value > 99 ? "99+" : value) : "");
      });
    }
  };

  $('input[type="checkbox"].js-switch-comparison-state').on(
    "change",
    function () {
      let currentState = $(this).is(":checked");
      // Не меняем состояние пока не выполним удачно запрос на добавление/удаление в сравнение
      $(this).prop("checked", !currentState);

      const product_id = $(this).data("product");
      const category_id = $(this).data("category");

      if (currentState === true) {
        // Добавим к сравнению
        $.ajax("/comparison/ajax/add", {
          method: "POST",
          data: { category_id: category_id, product_id: product_id },
        }).done((data) => {
          setComparisonCounter(data);
          $(this).prop("checked", currentState);
        });
      } else {
        // Удалим из сравнения
        $.ajax("/comparison/ajax/remove", {
          method: "POST",
          data: { category_id: category_id, product_id: product_id },
        }).done((data) => {
          setComparisonCounter(data);
          $(this).prop("checked", currentState);
        });
      }
    }
  );

  $(".js-compare-clear-category").on("click", function () {
    const category_id = $(this).data("category");

    if (category_id) {
      $.ajax("/comparison/ajax/clear_category", {
        method: "POST",
        data: { category_id: category_id },
      }).done((data) => {
        setComparisonCounter(data);
        location.reload();
      });
    }
  });

  $(".js-compare-hide-same").on("click", function () {
    const btn = $(this);
    if ($(this).data("hidden")) {
      $(this)
        .parents("section")
        .find(".js-compare-property")
        .each(function () {
          $(this).removeClass("d-none");
          $(btn).text($(btn).data('hide-text'));
          $(btn).data("hidden", false);
        });
    } else {
      $(this)
        .parents("section")
        .find(".js-compare-property")
        .each(function () {
          const values = $(this)
            .find(".js-compare-property-value")
            .map(function () {
              return $(this).data("property-value");
            })
            .get();
          const equal = new Set(values).size == 1;

          if (values && values.length && equal) {
            $(this).addClass("d-none");
            $(btn).text($(btn).data('show-text'));
            $(btn).data("hidden", true);
          }
        });
    }
  });

  $(".js-compare-prev-product").on("click", function (e) {
    const position = $(this).data("product-column");
    const total = $(this)
      .parents(".js-compare-products")
      .data("products-total");
    const current = $(this)
      .parents(".df-compare__table__product-info")
      .data("product-index");

    if (current > 1) {
      $(this)
        .parents(".df-compare__table__product-info")
        .removeClass("d-flex");
      $(this).parents(".df-compare__table__product-info").addClass("d-none");
      $(this)
        .parents(".df-compare__table__product-info")
        .prev(".df-compare__table__product-info")
        .removeClass("d-none");
      $(this)
        .parents(".df-compare__table__product-info")
        .prev(".df-compare__table__product-info")
        .addClass("d-flex");

      $(this)
        .parents(".js-compare-products")
        .find(".js-compare-product-" + position + " .js-compare-property-value")
        .each(function () {
          if ($(this).data("product-index") == current - 1) {
            $(this).removeClass("d-none");
          } else {
            $(this).addClass("d-none");
          }
        });
    }
  });

  $(".js-compare-next-product").on("click", function (e) {
    const position = $(this).data("product-column");
    const total = $(this)
      .parents(".js-compare-products")
      .data("products-total");
    const current = $(this)
      .parents(".df-compare__table__product-info")
      .data("product-index");

    if (current < total) {
      $(this)
        .parents(".df-compare__table__product-info")
        .removeClass("d-flex");
      $(this).parents(".df-compare__table__product-info").addClass("d-none");
      $(this)
        .parents(".df-compare__table__product-info")
        .next(".df-compare__table__product-info")
        .removeClass("d-none");
      $(this)
        .parents(".df-compare__table__product-info")
        .next(".df-compare__table__product-info")
        .addClass("d-flex");

      $(this)
        .parents(".js-compare-products")
        .find(".js-compare-product-" + position + " .js-compare-property-value")
        .each(function () {
          if ($(this).data("product-index") == current + 1) {
            $(this).removeClass("d-none");
          } else {
            $(this).addClass("d-none");
          }
        });
    }
  });
});
